import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import VueBus from "vue-bus";
import VueSweetalert2 from "vue-sweetalert2";
import miniToastr from "mini-toastr";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";



Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);

Vue.prototype.$axios = axios;
Vue.prototype.$appName = "AguilaPrint";
Vue.config.productionTip = false;

Vue.use(VueBus);

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
};
miniToastr.init({ types: toastTypes });
Vue.use(miniToastr);
Vue.prototype.$toast = miniToastr;

axios.defaults.baseURL = "https://api.aguilaprint.com";
//axios.defaults.baseURL = "http://localhost:3000";

/* router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      next({
        name: "login",
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
}); */
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
